import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ExternalUserService } from '@externaluserservice/external-user.service';
import { ChaseUIDRequest } from '@externalusermodel/AdvancePayment';
import { ChaseProfileTransactionData } from '@externalusermodel/ChaseProfileTransactionData';
import { Location } from '@angular/common';


@Component({
    selector: 'app-chase-gateway',
    templateUrl: './chase-gateway.component.html',
    styleUrls: ['./chase-gateway.component.css'],
    providers: [ExternalUserService],
    standalone: false
})
export class ChaseGatewayComponent implements OnInit {

  url: string;
  urlSafe: SafeResourceUrl;
  uID: string;
  private sub: any;
  showIframe: boolean;

  chaseOrderId: string;
  paymentType: string;
  profileDetail: any = [];
  UserID: string;
  selectedProfile: any;
  amount: string;

  isCreateNewProfileDisabled: boolean;
  isCreateNewProfileCheckboxDisabled: boolean;
  isProfileSubmitDisabled: boolean;

  createNewProfile: boolean;
  transactionType: string;


  previousRoute: string;

  isPayExistingProfileInProgress: boolean;

//   for message Display
Transactionmessage: boolean;

  constructor(public sanitizer: DomSanitizer, private route: ActivatedRoute, private externalUserService: ExternalUserService, private router: Router, private _location: Location) {
    this.createNewProfile = false;
  }

  ngOnInit() {
    //debugger;
    this.chaseOrderId = this.route.snapshot.params.chaseOrderId;
    this.paymentType = this.route.snapshot.params.paymentType;
    this.transactionType = this.route.snapshot.params.transactionType;
    this.UserID = sessionStorage.getItem('userid');

    switch(this.transactionType)
    {
      case "Invoice":
      this.previousRoute = "InvoiceDetail";
      break;

      case "Advance":
      this.previousRoute = "AdvanceDetail";
      break;

      case "Order":
      this.previousRoute = "OrderDetail";
      break;

      case "OrderInvoice":
      this.previousRoute = "OrderInvoiceDetail";
      break;

      default:
      break;
    }

    this.externalUserService.getTransactionAmountFromChaseOrderId(this.chaseOrderId).subscribe(

      response => {
        // debugger;
        this.amount = response;
      }

    );

    this.externalUserService.getProfileList(this.UserID, this.paymentType).subscribe(

      response => {
        // debugger;
        this.profileDetail = response;
      }

    );

  }


  SelectedState(value) {
    // debugger;
    if (value) {
      this.isCreateNewProfileDisabled = true;
      this.isProfileSubmitDisabled = false;
    }

  }

  goback() {
    sessionStorage.removeItem('selectedAccExe');
    this.router.navigate([this.previousRoute, this.chaseOrderId]);
    //this._location.back();
  }

  PayUsingNewProfile() {
    //debugger;
    
    this.isCreateNewProfileCheckboxDisabled = true;

    let uIDRequestData = new ChaseUIDRequest();
    uIDRequestData.amount = this.amount;
    uIDRequestData.paymentType = this.paymentType;
    uIDRequestData.transactionType = this.transactionType;
    uIDRequestData.chaseOrderId = this.chaseOrderId;
    uIDRequestData.isCreateNewProfile = this.createNewProfile;

    this.externalUserService.GetOrderUId(uIDRequestData)
      .subscribe((result) => {
        this.uID = result;
        
        if (this.isValidUID(this.uID)) {
          const encodedUID = encodeURIComponent(this.uID);
        this.url = 'https://www.chasepaymentechhostedpay.com/securepayments/a1/cc_collection.php?uID=' + this.uID;
          if (this.isValidChasePaymentURL(this.url)) {
            this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
            this.showIframe = true;
            this.Transactionmessage = true;
          } else {
            console.error('Invalid Chase payment URL');
          }
        } else {
          console.error('Invalid uID received from server');
        }
      });
  }

  // Validate uID contains only safe characters
  private isValidUID(uid: string): boolean {
    if (!uid || uid.trim().length === 0) {
      return false;
    }
    const validPattern = /^[a-zA-Z0-9_-]+$/;
    return validPattern.test(uid);
  }

  private isValidChasePaymentURL(url: string): boolean {
    try {
      const urlObj = new URL(url);
      return urlObj.protocol === 'https:' && 
             urlObj.hostname === 'www.chasepaymentechhostedpay.com' &&
             urlObj.pathname === '/securepayments/a1/cc_collection.php';
    } catch (e) {
      return false;
    }
  }

  PayUsingExistingProfile() {
    // debugger;
    let transData = new ChaseProfileTransactionData();

    transData.ChaseOrderId = this.chaseOrderId;
    transData.ProfileReference = this.selectedProfile.chaseProfileID;
    //transData.TransactionAmount = this.amount;
    transData.PaymentType = this.transactionType === 'OrderInvoice' ? 'Invoice' : this.transactionType;

    //console.log(transData);
    
    this.isPayExistingProfileInProgress = true;

    this.externalUserService.ChaseProfileTransaction(transData)
      .subscribe((result) => {
        this.isPayExistingProfileInProgress = false;
        // debugger;

        switch (this.transactionType) {
          case 'Order': {
            this.router.navigate(['OrderStatusProfile', this.chaseOrderId, result === 'Success' ? 'Success' : 'Failure']);
            break;
          }
          case 'Invoice': {
            this.router.navigate(['InvoiceStatusProfile', this.chaseOrderId, result === 'Success' ? 'Success' : 'Failure']);
            break;
          }
          case 'OrderInvoice': {
            this.router.navigate(['OrderInvoiceStatusProfile', this.chaseOrderId, result === 'Success' ? 'Success' : 'Failure']);
            break;
          }
          case 'Advance': {
            this.router.navigate(['AdvancePaymentStatusProfile', this.chaseOrderId, result === 'Success' ? 'Success' : 'Failure']);
            break;
          }
        }

      });

  }

}
